<!-- 评分评价-->
<template>
  <div id="grade">
    <div class="grade-box">
      <div class="breadcrumb-box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item @click.native="$router.back(-1)"
            >企业测评</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ info.brandName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="grade-title">
        <div>
          <h3>{{ info.brandName }}</h3>
          <div class="grade-title-info">
            时间：
            <span>{{ info.workDates }}</span>
            <span class="kg-class"></span>
            等级：
            <span> {{ info.grade != 1 ? "合格" : "不合格" }}</span>
          </div>
        </div>
        <div class="grade-title-num">
          {{ Number((100 - rankDetail.total).toFixed(2)) }}
          <span>分</span>
        </div>
        <img
          src="@/assets/image/tui2.png"
          class="out"
          v-if="info.isOut"
          @click="getTip(info)"
        />
      </div>
      <div class="grade-content">
        <div class="grade-header">
          <el-row type="flex">
            <el-col :span="3"> 分类 </el-col>
            <el-col :span="4"> 考核项目 </el-col>
            <el-col :span="4"> 考核内容 </el-col>
            <el-col :span="10"> 考核描述 </el-col>
            <el-col :span="1" style="margin-right:30px "> 扣分上限 </el-col>
            <el-col :span="1" > 扣分 </el-col>
            <el-col :span="1"> 详情 </el-col>
          </el-row>
        </div>
        <div class="grade-items" v-for="i in brandDetail" :key="i.examineId">
          <el-row class="grade-row" type="flex">
            <el-col :span="3" class="grade-items-brand">{{
              i.categoryName
            }}</el-col>
            <el-col :span="21">
              <el-row type="flex" v-for="(item, k) in i.children" :key="k">
                <el-col :span="4"> {{ item.categoryName2 }}</el-col>
                <el-col :span="20">
                  <el-row type="flex" v-for="(p, k) in item.children" :key="k">
                    <el-col :span="6" class="grade-items-text">{{
                      p.ruleName
                    }}</el-col>
                    <el-col :span="12" class="grade-items-text">
                      {{ p.description }}</el-col>
                    <el-col
                      :span="3"
                      class="grade-items-text"
                      style="padding-left: 110px">
                      {{ p.scoreLimit>0 ? p.scoreLimit : '/'}}</el-col>
                    <el-col
                      :span="2"
                      class="grade-items-text"
                      style="color: #ff544d;padding-left: 35px;">
                      {{ p.score > p.scoreLimit ? (p.scoreLimit>0 ? p.scoreLimit : p.score) : p.score}}</el-col>
                    <el-col :span="1" class="grade-items-text">
                      <el-button
                        type="text"
                        @click="onShowComponent(p)"
                        v-if="p.score"
                        >查看</el-button
                      >
                      <span v-else>-</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <koufen
      :infoShow="infoShow"
      :rankDetail="info"
      :detailTotal="detailTotal"
      :selfAreaId="id"
      @closepop="closepop"
    ></koufen>
  </div>
</template>

<script>
import koufen from './components/koufen'
import Api from '@/api'
export default {
  name: 'grade',
  components: {
    koufen
  },
  data() {
    return {
      id: '',
      info: {},
      infoShow: false,
      brandId: '',
      detailTotal: {},
      rankDetail: {}
    }
  },
  computed: {
    brandDetail() {
      if (this.rankDetail.brandDetail) {
        let arr = [
          this.rankDetail.detail4,
          this.rankDetail.detail2,
          this.rankDetail.detail3,
          this.rankDetail.detail1,
          this.rankDetail.detail6,
          this.rankDetail.detail5,
          ...this.rankDetail.category
        ]
        arr = arr.map(p => {
          const value = this.rankDetail.brandDetail.find(val => val.examineId == p.examineId)// 重复
          p = value || p
          return p
        })
        let arr2 = []
        for (const i of arr) {
          const index = arr2.findIndex((val) => {
            return val.categoryName == i.categoryName
          })
          if (index == -1) {
            arr2.push({
              categoryName: i.categoryName,
              children: [i]
            })
          } else {
            arr2[index].children.push(i)
          }
        }
        if (arr2.length > 0) {
          arr2 = arr2.map((data) => {
            const arr3 = []
            for (const i of data.children) {
              const index = arr3.findIndex((val) => {
                return val.categoryName2 == i.categoryName2
              })
              if (index == -1) {
                arr3.push({
                  categoryName2: i.categoryName2,
                  children: [i]
                })
              } else {
                arr3[index].children.push(i)
              }
            }
            return {
              categoryName: data.categoryName,
              children: arr3
            }
          })
        }
        return arr2
      } else {
        return []
      }
    }
  },
  created() {
    this.id = this.$route.params.id
    this.info = JSON.parse(this.$route.query.data)
    const { brandId, workDate } = this.info
    this.info.workDates = this.dayjs(workDate + '').format(
      'YYYY年MM月考评细则'
    )
    Api.getRankDetail({ brandId, workDate, selfAreaId: this.id }).then(
      ({ data }) => {
        this.rankDetail = data
      }
    )
  },
  methods: {
    // 点击统计按钮，弹出组件
    onShowComponent(val) {
      this.detailTotal = val
      this.infoShow = true
    },
    // 组件返回关闭组件操作
    closepop() {
      this.infoShow = false
    },
    getTip(data) {
      Api.getBrandOut({
        selfAreaId: this.id,
        brandId: data.brandId,
        type: 'month',
        now: data.workDate
      }).then(({ data }) => {
        const reason = []
        if (data.length > 0) {
          data.forEach((val) => {
            val.infoBak = JSON.parse(val.infoBak)
            console.log(val.infoBak)
            if (val.infoBak.examineInfo) {
              val.infoBak.examineInfo = JSON.parse(val.infoBak.examineInfo)
              const name = val.infoBak.examineInfo.title
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
            if (val.source) {
              const name = { 100: '重点区域偏多调度', 150: '普通区域偏多调度', 200: '站外还车调度', 250: '非法车辆调度'}[val.source]
              if (!reason.includes(name)) {
                reason.push(name)
              }
            }
          })
        }
        this.$alert(
          `<p>违反了“<span style='color:#1F8FFB'>${reason.join(',')}</span>”考核内容设置，按照规则触发退市。</p>`,
          '退市说明',
          {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false
          }
        )
      })
    }
  }
}
</script>
<style scoped lang="less">
#grade {
  overflow: auto;
  .grade {
    &-title {
      font-size: 18px;
      line-height: 36px;
      text-align: left;
      background: #fff;
      margin-bottom: 16px;
      padding: 24px 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      &-info {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.25);
        span {
          color: rgba(0, 0, 0, 0.45);
        }
        .kg-class {
          margin-left: 55px;
        }
      }
      &-num {
        color: #44acff;
        font-size: 34px;
        line-height: 60px;
        span {
          font-size: 16px;
        }
      }
      .out {
        position: absolute;
        right: 0;
        bottom: 0;
        cursor: pointer;
      }
    }

    &-box {
      padding: 16px;
      .breadcrumb-box {
        /deep/ .el-breadcrumb {
          line-height: 36px;
        }
      }
    }
    &-header {
      background: #fafafc;
      line-height: 40px;
      .el-col {
        padding-left: 20px;
      }
    }
    &-content {
      padding-bottom: 30px;
    }
    &-items {
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      line-height: 18px;
      .el-row {
        border-bottom: 1px solid #ebebeb;
        align-items: center;
        padding-left: 20px;
        .el-row:last-child {
          border-bottom: 0;
        }
        .grade-items-text {
          padding: 18px 0;
        }
      }
    }
  }
}
</style>
